import { render, staticRenderFns } from "./setGoodOfScanProperty.vue?vue&type=template&id=c63b2384&scoped=true"
import script from "./setGoodOfScanProperty.vue?vue&type=script&lang=js"
export * from "./setGoodOfScanProperty.vue?vue&type=script&lang=js"
import style0 from "./setGoodOfScanProperty.vue?vue&type=style&index=0&id=c63b2384&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63b2384",
  null
  
)

export default component.exports